import React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Button} from "@mui/material";

export const DraftBoardGrid = ({rows, onBiddingButtonClick}) => {

    const renderBiddingButton = (params) => {
        if (!params.row.bid_group_is_open) return "Closed"
        const onClick = async () => {
            onBiddingButtonClick(params.row)
        }
        return (
            <Button color="primary" onClick={onClick} style={{padding: 0}}>Bidding</Button>
        );
    };

    const common = {sortable: false, disableColumnMenu: true, headerClassName: 'grid-header'};
    const bidGroupListColumns = [
        {...common, width: 55, headerName: 'Num', field: 'row_number'},
        {...common, width: 130, headerName: 'First Name', field: 'first_name'},
        {...common, width: 170, headerName: 'Last Name', field: 'last_name'},
        {...common, width: 60, headerName: 'Pos', field: 'pos', headerAlign: 'center', align: 'center'},
        {...common, width: 70, headerName: 'Team', field: 'team', headerAlign: 'center', align: 'center'},
        {...common, width: 110, headerName: 'Nominated By', field: 'nominating_manager', headerAlign: 'center', align: 'center'},
        {...common, width: 80, headerName: 'High Bid', field: 'high_bid', type: 'number', headerAlign: 'right'},
        {...common, width: 110, headerName: 'High Bidder', field: 'high_bidder', headerAlign: 'center', align: 'center'},
        {...common, width: 105, headerName: ' ', field: 'bidding', align: 'center', renderCell: renderBiddingButton}
    ];

    const calcWidth = (cols) => {
        return cols.reduce((t, c) => t + c.width, 0) + 2;
    };

    const determineRowClass = (params) => {
        return `${params.row.row_number % 2 === 1 ? 'table-row-odd' : 'table-row-even'}`
    };

    return (
        <div style={{width: calcWidth(bidGroupListColumns), marginBottom: 50}}>
            <DataGrid columns={bidGroupListColumns} rows={rows} hideFooter={true}
                      columnHeaderHeight={30} rowHeight={23}
                      getRowClassName={(params) => (determineRowClass(params))}
                      disableRowSelectionOnClick disableMultipleRowSelection disableColumnResize/>
        </div>
    );
}
